import { render, staticRenderFns } from "./remarkGuadan.vue?vue&type=template&id=c43d63ce&scoped=true&"
import script from "./remarkGuadan.vue?vue&type=script&lang=js&"
export * from "./remarkGuadan.vue?vue&type=script&lang=js&"
import style0 from "./remarkGuadan.vue?vue&type=style&index=0&id=c43d63ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43d63ce",
  null
  
)

export default component.exports